import http from "./client"


async function signupForEvent(eventId: number, data: FormData) {
  http.post(`/api/promotion-events/${eventId}`, data);
}

async function getEvents() {
  const response =  await http.get('/api/promotion-events');
  return response.data;
}

const platformPromoEvents = {
  signupForEvent, getEvents
}

export default platformPromoEvents